import PageClient from "components/organisms/PageClient";
import React, { useEffect } from "react";
import "./index.scss";
import HeaderImage from "assets/images/services-header.png";
import SectionClient from "components/organisms/SectionClient";
import { useTranslation } from "react-i18next";
import { Collapse, Tabs } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import TaxesAndRedevances from "assets/images/TaxesAndRedevances.PNG";
import CertificationRedevances from "assets/images/CertificationRedevances.PNG";
import FileList from "components/organisms/FileList";
import { useDispatch, useSelector } from "react-redux";
import { getAllServices } from "store/services/actions";
import { Parallax } from "rc-scroll-anim";

const { Panel } = Collapse;
const { TabPane } = Tabs;

const MunicipalityPage = (props) => {
  const { t } = useTranslation();
  const { listServices } = useSelector((state) => state.services);
  const dispatch = useDispatch();

  const subMenu = [
    {
      title: "Urbanisme et permis de bâtir",
      id: "#urbanisme",
      child: null,
    },
    {
      title: "Etat Civil",
      id: "#etat_civil",
      child: null,
    },
    {
      title: "Légalisation de la signature",
      id: "#egalisation_signature",
      child: null,
    },
    {
      title: "Certification des conformités des copies",
      id: "#certification_conformités",
      child: null,
    },
    {
      title: "Autorisation économique",
      id: "#autorisation_economique",
      child: null,
    },
  ];

  useEffect(() => {
    dispatch(getAllServices());
  }, [dispatch]);

  return (
    <>
      <PageClient
        title="Services"
        description="Services municipaux et démarches administratives"
        headerImage={HeaderImage}
        menu={subMenu}
      >
        <div className="service-page">
          <Parallax
            animation={{ x: 0, opacity: 1, playScale: [0.1, 0.5] }}
            style={{ transform: "translateX(100px)", opacity: 0 }}
          >
            <SectionClient id="urbanisme" title="Urbanisme et permis de bâtir">
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusCircleOutlined rotate={isActive ? 90 : 0} />
                )}
                className="site-collapse-custom-collapse"
              >
                <Panel
                  header={t("Permis de bâtir")}
                  className="site-collapse-custom-panel"
                >
                  <p>
                    {t(
                      "Toute personne souhaitant construire, ou procéder à des travaux de restauration d'une construction déjà existante ou y apporter des modifications, doit obtenir un permis de bâtir."
                    )}
                  </p>

                  <p className="sub-title-service">{t("Pièces à fournir :")}</p>
                  <p>{t("urbanismePiece")}</p>

                  <p className="sub-title-service">
                    {t(
                      "Validité du permis de bâtir, sa prorogation et son renouvellement :"
                    )}
                  </p>
                  <p>{t("urbanismeValidite")}</p>

                  <p className="sub-title-service">
                    {t(
                      "Délais de réponse aux demandes de l'autorisation de bâtir :"
                    )}
                  </p>
                  <p>{t("urbanismeDelais")}</p>
                  <ul>
                    <li>
                      <p>{t("urbanismeDelaisList1")}</p>
                    </li>
                    <li>
                      <p>{t("urbanismeDelaisList2")}</p>
                      <ul>
                        <li>
                          {" "}
                          <p>{t("urbanismeDelaisList2_1")}</p>
                        </li>
                        <li>
                          {" "}
                          <p>{t("urbanismeDelaisList2_2")}</p>
                        </li>
                        <li>
                          {" "}
                          <p>{t("urbanismeDelaisList2_3")}</p>
                        </li>
                        <li>
                          {" "}
                          <p>{t("urbanismeDelaisList2_4")}</p>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p className="sub-title-service">{t("proces-verbal")}</p>
                  <p>{t("urbanismeDelais")}</p>
                  <ul>
                    <li>
                      <p>{t("proces-verbal1-1")}</p>
                    </li>
                    <li>
                      <p>{t("proces-verbal1-2")}</p>
                    </li>
                  </ul>
                  <p className="sub-title-service">{t("Transformation")}</p>
                  <p>{t("Transformation1")}</p>
                </Panel>
                <Panel
                  header={t("Plan d’aménagement urbain")}
                  className="site-collapse-custom-panel"
                >
                  <Tabs
                    defaultActiveKey="1"
                    centered
                    className="tabs-open-data"
                    type="card"
                    size="large"
                  >
                    <TabPane tab={t("Avis")} key="1">
                      <FileList
                        files={listServices.filter(
                          ({ type, tab }) =>
                            type === "UrbanDevelopmentPlan" && tab === "Avis"
                        )}
                      ></FileList>
                    </TabPane>
                    <TabPane tab={t("Résultats")} key="2">
                      <FileList
                        files={listServices.filter(
                          ({ type, tab }) =>
                            type === "UrbanDevelopmentPlan" &&
                            tab === "Résultats"
                        )}
                      ></FileList>
                    </TabPane>
                  </Tabs>
                </Panel>
                <Panel
                  header={t(
                    "Les résultats des commissions locales des permis de bâtir"
                  )}
                  className="site-collapse-custom-panel"
                >
                  <Tabs
                    defaultActiveKey="1"
                    centered
                    className="tabs-open-data"
                    type="card"
                    size="large"
                  >
                    <TabPane tab={t("Avis")} key="1">
                      <FileList
                        files={listServices.filter(
                          ({ type, tab }) =>
                            type === "ResultsLocalBuildingPermitCommissions" &&
                            tab === "Avis"
                        )}
                      ></FileList>
                    </TabPane>
                    <TabPane tab={t("Résultats")} key="2">
                      <FileList
                        files={listServices.filter(
                          ({ type, tab }) =>
                            type === "ResultsLocalBuildingPermitCommissions" &&
                            tab === "Résultats"
                        )}
                      ></FileList>
                    </TabPane>
                  </Tabs>
                </Panel>
              </Collapse>
            </SectionClient>
          </Parallax>
          <Parallax
            animation={{ x: 0, opacity: 1, playScale: [0.1, 0.5] }}
            style={{ transform: "translateX(-100px)", opacity: 0 }}
          >
            <SectionClient id="etat_civil" title="Etat Civil">
              <p className="medium-text">{t("etat-civil-description")}</p>
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusCircleOutlined rotate={isActive ? 90 : 0} />
                )}
                className="site-collapse-custom-collapse"
              >
                <Panel
                  header={t("La naissance")}
                  className="site-collapse-custom-panel"
                >
                  <p>{t("naissance1")}</p>
                  <p className="sub-title-service">{t("Qui déclare ?")}</p>
                  <p>{t("déclare1")}</p>
                  <p className="sub-title-service">
                    {t("Quand la déclaration doit-elle être faite ?")}
                  </p>
                  <p>{t("quand-déclare1")}</p>
                  <p className="sub-title-service">
                    {t("Qui reçoit les déclarations ?")}
                  </p>
                  <p>{t("Les agents du Service de l’état civil.")}</p>
                  <p className="sub-title-service">{t("NB :")}</p>
                  <p>
                    {t(
                      "le mort-né n’est pas enregistré dans le registre des naissances, mais uniquement dans le registre des décès"
                    )}
                  </p>
                </Panel>

                <Panel
                  header={t("Le mariage")}
                  className="site-collapse-custom-panel"
                >
                  <p>{t("mariage1")}</p>
                  <p className="sub-title-service">{t("Les conditions")}</p>
                  <p>{t("conditions_mariage1")}</p>
                  <p className="sub-title-service">
                    {t(
                      "Quelles sont les pièces constitutives du dossier de mariage ?"
                    )}
                  </p>
                  <p>{t("pièces_mariage1")}</p>

                  <p className="sub-title-service">
                    {t("NB: LE MARIAGE DES ETRANGERS")}
                  </p>
                  <p>{t("mariageETRANGERS")}</p>
                  <p className="sub-title-service">
                    {t("Où peut-on contracter mariage ?")}
                  </p>
                  <p>{t("contracter_mariage")}</p>
                </Panel>

                <Panel
                  header={t("Le décès")}
                  className="site-collapse-custom-panel"
                >
                  <p className="sub-title-service">
                    {t("Quel est l’officier d’Etat civil compétent ?")}
                  </p>
                  <p>{t("officier_décès")}</p>
                  <p className="sub-title-service">
                    {t("Pièces_a_fournir_deces")}
                  </p>
                  <p>{t("pièces_décès")}</p>

                  <p className="sub-title-service">
                    {t("Délai de la déclaration")}
                  </p>
                  <p>{t("Le délai de la déclaration est de 3 jours.")}</p>
                  <p className="sub-title-service">
                    {t("Les personnes tenues de déclarer")}
                  </p>
                  <p>{t("personnes_déclarer_décès")}</p>
                  <p className="sub-title-service">{t("NB :")}</p>
                  <p>{t("NB_décès")}</p>
                </Panel>

                <Panel
                  header={t("Rectification des Actes d'Etat Civil")}
                  className="site-collapse-custom-panel"
                >
                  <p>{t("Rectification_desciption")}</p>

                  <p className="sub-title-service">{t("Procédure")}</p>
                  <p>{t("Rectification_procédure")}</p>
                </Panel>

                <Panel
                  header={t("Le livret de famille")}
                  className="site-collapse-custom-panel"
                >
                  <p>{t("livret_desciption")}</p>

                  <p className="sub-title-service">{t("Qui le délivre ?")}</p>
                  <p>{t("délivre_livret")}</p>

                  <p className="sub-title-service">
                    {t("A qui le délivre-t-on ?")}
                  </p>
                  <p>{t("délivre_livret_a_qui")}</p>

                  <p className="sub-title-service">{t("Pièces nécessaires")}</p>
                  <p>{t("pièces_livret")}</p>

                  <p className="sub-title-service">{t("Délai")}</p>
                  <p>
                    {t(
                      "Le livret de famille est délivré immédiatement, si le mariage a été contracté à la mairie."
                    )}
                  </p>

                  <p className="sub-title-service">{t("NB :")}</p>
                  <p>
                    {t(
                      "Il n’est permis à aucune personne autre que l’officier de l’état civil dûment habilité de porter une observation ou une mention quelconque sur le livret de famille. Celui-ci n’est délivré qu'aux Tunisiens."
                    )}
                  </p>
                </Panel>
              </Collapse>
            </SectionClient>
          </Parallax>
          <Parallax
            animation={{ x: 0, opacity: 1, playScale: [0.1, 0.5] }}
            style={{ transform: "translateX(100px)", opacity: 0 }}
          >
            <SectionClient
              id="egalisation_signature"
              title="Légalisation de la signature"
            >
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusCircleOutlined rotate={isActive ? 90 : 0} />
                )}
                className="site-collapse-custom-collapse"
              >
                <Panel
                  header={t("Formalités obligatoires")}
                  className="site-collapse-custom-panel"
                >
                  <p>{t("formalités_légalisation")}</p>
                </Panel>

                <Panel
                  header={t("Pièces à fournir")}
                  className="site-collapse-custom-panel"
                >
                  <p>
                    {t(
                      "La légalisation de signature est effectuée après présentation de l'une des pièces d'identité officielles suivantes en cours de validité :"
                    )}
                  </p>

                  <ul>
                    <li>
                      <p>{t("Pièces_légalisation1")}</p>
                    </li>
                    <li>
                      <p>{t("Pièces_légalisation2")}</p>
                    </li>
                    <li>
                      <p>{t("Pièces_légalisation3")}</p>
                    </li>
                  </ul>
                </Panel>

                <Panel
                  header={t("Le spécimen de signature")}
                  className="site-collapse-custom-panel"
                >
                  <p>
                    {t(
                      "Tout particulier qui demande fréquemment la légalisation de sa signature peut en déposer personnellement le spécimen auprès du service de l'état civil."
                    )}
                  </p>
                </Panel>

                <Panel
                  header={t("Taxes et redevances")}
                  className="site-collapse-custom-panel"
                >
                  <p>
                    {t(
                      "La légalisation de signature pour les particuliers est soumise à des redevances. Le montant de ces taxes est fixé comme suit :"
                    )}
                  </p>
                  <img
                    src={TaxesAndRedevances}
                    alt="Taxes et redevances"
                    className="image-description"
                  />
                </Panel>
              </Collapse>
            </SectionClient>
          </Parallax>
          <Parallax
            animation={{ x: 0, opacity: 1, playScale: [0.1, 0.5] }}
            style={{ transform: "translateX(-100px)", opacity: 0 }}
          >
            <SectionClient
              id="certification_conformités"
              title="Certification des conformités des copies"
            >
              <p className="medium-text">
                {t("certification_conformités_description")}
              </p>
              <div className="certification-page">
                <p className="sub-title-service">{t("Taxes et redevances")}</p>
                <p>
                  {t(
                    "La certification de conformité des copies à l'original est soumise à des redevances. Le montant de ces taxes est fixé comme suit :"
                  )}
                </p>
                <img
                  src={CertificationRedevances}
                  alt="Taxes et redevances"
                  className="image-description"
                />

                <p className="sub-title-service">{t("NB :")}</p>
                <p>{t("NB-conformités-redevances")}</p>
              </div>
            </SectionClient>
          </Parallax>
          <Parallax
            animation={{ x: 0, opacity: 1, playScale: [0.1, 0.5] }}
            style={{ transform: "translateX(100px)", opacity: 0 }}
          >
            <SectionClient
              id="autorisation_economique"
              title="Autorisation économique"
            >
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusCircleOutlined rotate={isActive ? 90 : 0} />
                )}
                className="site-collapse-custom-collapse"
              >
                <Panel
                  header={t("Certificat de validité de local")}
                  className="site-collapse-custom-panel"
                >
                  <p className="sub-title-service">
                    {t("Pièces nécessaires à la constitution d'un dossier")}
                  </p>
                  <p>{t("Pièces-Certificat-validité")}</p>
                  <p className="sub-title-service">{t("Délai de réponse")}</p>
                  <p>
                    {t(
                      "Vingt (20) jours à partir de la date du dépôt d'un dossier dûment constitué"
                    )}
                  </p>
                </Panel>

                <Panel
                  header={t(
                    "Autorisation d'occupation de la voie publique pour l'exercice de certains métiers"
                  )}
                  className="site-collapse-custom-panel"
                >
                  <p className="sub-title-service">{t("Pièces à fournir")}</p>
                  <p>{t("Pièces-Autorisation-occupation")}</p>
                  <p className="sub-title-service">{t("Délai de réponse")}</p>
                  <p>
                    {t(
                      "Dans les Vingt (20) jours à partir de la date de dépôt d'un dossier dûment constitué"
                    )}
                  </p>
                  <p className="sub-title-service">
                    {t("Validité de l'autorisation")}
                  </p>
                  <p>
                    {t(
                      "L'autorisation d'occupation de la voie publique pour l'exercice de certains métiers délivrée sous forme d'arrêté municipal est valable pour une année."
                    )}
                  </p>
                </Panel>

                <Panel
                  header={t(
                    "Autorisation pour l'occupation temporaire de la voie publique"
                  )}
                  className="site-collapse-custom-panel"
                >
                  <p className="medium-text">
                    {t("Autorisation-occupation-voie-publique-description")}
                  </p>

                  <p className="sub-title-service">{t("Pièces à fournir")}</p>
                  <p>
                    {t(
                      "Pièces-Autorisation-occupation-voie-publique-description"
                    )}
                  </p>
                  <p className="sub-title-service">{t("Délai de réponse")}</p>
                  <p>
                    {t(
                      "Dans les vingt (20) jours à partir de la date de dépôt d'un dossier dûment constitué"
                    )}
                  </p>
                </Panel>
              </Collapse>
            </SectionClient>
          </Parallax>
        </div>
      </PageClient>
    </>
  );
};

export default MunicipalityPage;
